import React, { useState } from 'react';
import { connect } from 'react-redux';

import { cloneDeep, isEmpty } from 'lodash';
import clsx from 'clsx';

import TextField from '@material-ui/core/TextField';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as BasAgentActions from '../../../actions/basAgentActions';

import * as classes from './RenameBasAgentModal.module.css';

const RenameBasAgentModal = ({
    activeNavCompany,
    agent,
    setRenameAgentModalOpen,
    updateBasAgent,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [newAgentName, setNewAgentName] = useState('');

    const handleNameChange = event => {
        setNewAgentName(event.target.value);
    };

    const handleUpdateAgent = async () => {
        let updatedAgent = cloneDeep(agent);

        updatedAgent.name = newAgentName;
        setIsLoading(true);
        let isUpdated = await updateBasAgent(activeNavCompany.id, updatedAgent.id, updatedAgent);
        setIsLoading(false);

        if (isUpdated) setRenameAgentModalOpen(false);
    };

    return (
        <BobModal
            title={'Rename Agent'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setRenameAgentModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.NamePanel}>
                    <div className={classes.Title}>
                        Agent Name
                    </div>
                    <div className={classes.IntegrationName}>
                        {agent.name}
                    </div>
                </div>
                <div className={classes.InputPanel}>
                    <TextField
                        key="New Agent Name"
                        id="standard-required"
                        label={<span>New Agent Name<span className={classes.Required}> *</span></span>}
                        placeholder="Enter"
                        value={newAgentName}
                        onChange={handleNameChange}
                        size="small"
                        inputProps={{
                            style: { fontSize: 14 }
                        }}
                        InputLabelProps={{
                            className: classes.NameLabel
                        }}
                        className={classes.NameInput}
                        variant="outlined"
                    />
                    <div className={classes.HelperText}>
                        <i className={clsx('fas fa-info-circle', classes.HelpIcon)} /> Please enter the new name for this Agent.
                    </div>
                </div>
                <div className={classes.ButtonPanel}>
                    <BobCancelButton
                        disabled={isLoading}
                        onClick={() => setRenameAgentModalOpen(false)}
                        className={classes.CancelButton}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        disabled={isEmpty(newAgentName) || isLoading}
                        onClick={() => handleUpdateAgent()}
                        className={isEmpty(newAgentName) || isLoading ? classes.DisabledButtons : classes.Buttons}
                        label={'Rename'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
});

const mapDispatchToProps = {
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(RenameBasAgentModal);
